// ECAL brand bar color pairs — from the 2026 Brand Guidelines
// Used to assign cover/logo gradients to publishers that arrive without pre-assigned colors
const ECAL_BAR_COLORS = [
    ['#FFDF10', '#FF9E00'],   // 1. warm1  — yellow → orange
    ['#FF9E00', '#FF4D00'],   // 2. warm2  — orange → deep orange
    ['#00D456', '#00D7FF'],   // 3. cool2  — green → light blue
    ['#00D7FF', '#0078FF'],   // 4. cool1  — light blue → mid blue
    ['#0078FF', '#000082'],   // 5. cool3  — mid blue → deep blue
    ['#FFDF10', '#FF4D00'],   // 6. warm full — yellow → deep orange
    ['#00D456', '#0078FF'],   // 7. cool full — green → mid blue
];

export const ECAL_BAR_COLOR_COUNT = ECAL_BAR_COLORS.length;

// Deterministic string hash (djb2-ish) so the same id always maps to the
// same index — used to keep a publisher's assigned color stable across
// refetches, instead of reassigning randomly every time.
function hashToIndex(seed, modulo) {
    let hash = 0;
    for (let i = 0; i < seed.length; i += 1) {
        hash = (hash * 31 + seed.charCodeAt(i)) | 0;
    }
    return Math.abs(hash) % modulo;
}

/**
 * Returns a random ECAL bar color pair from the set.
 * @returns {[string, string]} — [startColor, endColor]
 */
export function getPublisherColors() {
    return ECAL_BAR_COLORS[Math.floor(Math.random() * ECAL_BAR_COLOR_COUNT)];
}

/**
 * Returns a stable ECAL bar color pair for a given publisher id — same id
 * always resolves to the same color pair. Falls back to a random pick when
 * no id is available.
 * @param {string|number|undefined} id
 * @returns {[string, string]} — [startColor, endColor]
 */
export function getPublisherColorsForId(id) {
    if (id == null) return getPublisherColors();
    return ECAL_BAR_COLORS[hashToIndex(String(id), ECAL_BAR_COLOR_COUNT)];
}

/**
 * Assigns a random ECAL bar color pair to each publisher object.
 * Only fills in missing coverColors / logoColors — existing values are preserved.
 * @param {Array} publishers
 * @returns {Array} publishers with colors filled in
 */
export function assignPublisherColors(publishers) {
    return publishers.map((publisher) => {
        const colors = getPublisherColorsForId(publisher.pubId);
        return {
            ...publisher,
            coverColors: publisher.coverColors?.length ? publisher.coverColors : colors,
            logoColors:  publisher.logoColors?.length  ? publisher.logoColors  : colors,
        };
    });
}

export default ECAL_BAR_COLORS;
